"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
function assert(value, message) {
    if (!value) {
        throw new Error(`unreachable${message ? `: ${message}` : ''}`);
    }
}
exports.assert = assert;
